<template>
  <div class="account">
    <div class="completed" v-if="showRegistrationComplete">
      <p class="title">
        ランカルへようこそ！
      </p>

      <p class="message">
        登録が完了しました。<br>
        トライアル内容はマイページでいつでも確認できます。
      </p>

      <p><br>
        さっそくアプリをダウンロードして、<br>
        英語とカルチャーの世界へ飛び込みましょう！
      </p>

      <div class="app-links">
        <a href="https://apps.apple.com/jp/app/%E8%8B%B1%E4%BC%9A%E8%A9%B1%E3%82%AB%E3%83%95%E3%82%A7lancul/id1457671166">
          <img src="@/assets/apple_app_store.svg">
        </a>

        <a href='https://play.google.com/store/apps/details?id=com.lancul.lanculcustomers&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
          <img alt='Google Play で手に入れよう' src='@/assets/google-play-badge.png'/>
        </a>
      </div>
    </div>

    <div class="section">
      <div class="top">
        <p>ニックネーム</p>
        <p>{{nickname}}</p>
      </div>
      <button @click="$emit('open', 'EditInformation', 'ニックネーム')">編集</button>
    </div>

    <div class="line" />

    <div class="section">
      <div class="top">
        <p>自己紹介</p>
        <p>{{bio}}</p>
      </div>
      <button @click="$emit('open', 'EditInformation', '自己紹介')">編集</button>
    </div>

    <div class="line" />

    <div class="section">
      <div class="top">
        <p>プラン</p>
        <p>{{planDescription}}</p>
      </div>
      <!-- <button @click="$emit('open', 'ChangePlan')">変更</button> -->
    </div>

    <div class="line" />

    <div class="section">
      <div class="top campaign">
        <p>ご利用中の特典</p>
        <p>
          {{campaignName}}<br />
          {{campaignStartDate}}~{{campaignEndDate}}
        </p>
      </div>
    </div>

    <div class="line" />

    <div class="section">
      <div class="top">
        <p>支払い方法</p>
        <div class="cards">
          <CreditCard v-if="defaultCardBrand !== ''"
            :brand="defaultCardBrand"
            :last4="defaultCardLast4"
            :is-i-phone="isIPhone"
          />
        </div>
      </div>
      <button v-if="isStripeCustomerIdPresent" @click="$emit('open', 'PaymentMethod')">
        {{defaultCardBrand !== '' ? '変更' : '追加'}}
      </button>
    </div>

    <div class="line" />

    <div class="section profile">
      <div>
        <div class="top">
          <p>プロファイル</p>
        </div>

        <div class="details">
          <div class="info">
            <p>お名前</p>
            <p>{{name}}</p>
          </div>

          <div class="info">
            <p>性別</p>
            <p>{{gender}}</p>
          </div>

          <div class="info">
            <p>関心のある言語</p>
            <p>{{languageOfInterest}}</p>
          </div>

          <div class="info">
            <p>興味</p>
            <p>{{hobby}}</p>
          </div>

          <div class="info">
            <p>メールアドレス</p>
            <p>{{email}}</p>
          </div>

          <div class="info">
            <p>LanCul ID</p>
            <p>{{memberCode}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="app-links" v-if="!showRegistrationComplete">
      <a href="https://apps.apple.com/jp/app/%E8%8B%B1%E4%BC%9A%E8%A9%B1%E3%82%AB%E3%83%95%E3%82%A7lancul/id1457671166">
        <img src="@/assets/apple_app_store.svg">
      </a>

      <a href='https://play.google.com/store/apps/details?id=com.lancul.lanculcustomers&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
        <img alt='Google Play で手に入れよう' src='@/assets/google-play-badge.png'/>
      </a>
    </div>

    <div class="logout">
      <button @click="() => {showConfirmationOverlay = true}">ログアウト</button>
    </div>

    <ConfirmationOverlay
      :show-overlay="showConfirmationOverlay"
      @cancel="() => {showConfirmationOverlay = false}"
      @close="() => {showConfirmationOverlay = false; $emit('logout');}"
    />
  </div>
</template>

<script>
import CreditCard from '@/components/account/helpers/CreditCard.vue'
import ConfirmationOverlay from '@/components/helpers/ConfirmationOverlay.vue'

export default {
  name: 'Main',

  components: {
    CreditCard,
    ConfirmationOverlay
  },

  props: {
    nickname: {
      type: String,
      required: true
    },

    bio: {
      type: String,
      required: true
    },

    planDescription: {
      type: String,
      required: true
    },

    defaultCardBrand: {
      type: String,
      required: true
    },

    defaultCardLast4: {
      type: String,
      required: true
    },

    name: {
      type: String,
      required: true
    },

    gender: {
      type: String,
      required: true
    },

    languageOfInterest: {
      type: String,
      required: true
    },

    hobby: {
      type: String,
      required: true
    },

    email: {
      type: String,
      required: true
    },

    memberCode: {
      type: String,
      required: true
    },

    isStripeCustomerIdPresent: {
      type: Boolean,
      required: true
    },

    showRegistrationComplete: {
      type: Boolean,
      required: true
    },

    isIPhone: {
      type: Boolean,
      default: false
    },

    campaignName: {
      type: String,
      required: true
    },

    campaignStartDate: {
      type: String,
      required: true
    },

    campaignEndDate: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      showConfirmationOverlay: false
    }
  }
}
</script>

<style scoped>
.account p {
  color: black;
}

.account .section {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  margin-bottom: 15px;
}

.account .section .top {
  display: flex;
}

.account .section .top p {
  font-size: 14px;
  line-height: 21px;
  max-width: 185px;
}

.account .section .top.campaign p {
  max-width: 200px;
}

.account .section .top > p:first-child {
  width: 110px;
  font-weight: 600;
}

.account .section .top > p:nth-child(2) {
  font-weight: 500;
}

.account .section button {
  font-size: 13px;
  line-height: 19.5px;
}

.account .section button, .account .logout button {
  color: #147efb;
  border: none;
  background-color: white;
}

.account .line {
  height: 1px;
  background-color: #B6B6B6;
  opacity: 0.5;
}

.account .profile .details {
  margin-left: 10px;
}

.account .profile .info {
  display: flex;
  margin-top: 8px;
}

.account .profile .info p {
  font-size: 12px;
  line-height: 18px;
  width: 100px;
}

.account .profile .info p:first-child {
  opacity: 0.5;
}

.account .app-links {
  display: flex;
  margin-top: 30px;
  justify-content: space-between;
}

.account .app-links a {
  display: flex;
  justify-content: center;
  width: 100%;
  text-decoration: none;
  cursor: pointer;
}

.account .app-links a:last-child {
  margin-top: 2px;
}

.account .app-links a:first-child img {
  width: 150px;
  height: 70.3px;
  padding: 12px;
  box-sizing: border-box;
}

.account .app-links a:last-child img {
  width: 168px;
  height: 65.0167px;
}

.account .app-links a + a {
  /* margin-left: 20px; */
}

.account .logout {
  display: flex;
  justify-content: center;
}

.account .logout button {
  margin-top: 20px;
  width: 100%;
  max-width: 335px;
  height: 40px;
  font-size: 14px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 1.12px;
  color: #999;
  background-color: white;
  border: 1px solid #999;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.12);
}

.account .copyright {
  margin: 40px -10px 0;
  color: #999;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
}

.completed .app-links {
  margin-bottom: 80px;
}

.completed p.title {
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  margin-bottom: 5px;
}

.completed p.message {
  font-size: 14px;
  line-height: 21px;
}

@media (max-width: 360px) {
  .account .section .top p {
    max-width: 127px;
  }

  .account .app-links a:first-child img {
    width: 120px;
    height: 56.24px;
    padding: 12px;
    box-sizing: border-box;
  }

  .account .app-links a:last-child img {
    width: 135px;
    height: 52.318px;
  }
}
</style>
